// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"_20Pj1VE"};